import { Link } from "@reach/router";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import ReactMarkdown from "react-markdown";
import gfm from "remark-gfm";
import theTextFile from "../assets/md/about.md";
import Layout from "../components/Layout";
const Page = (props: any) => {
  const [postMarkdown, setPostMarkdown] = useState("");
  useEffect(() => {
    fetch(theTextFile)
      .then((response) => response.text())
      .then((text) => {
        setPostMarkdown(text);
      });
  }, []);

  return (
    <Layout>
      <Main>
        {/* <ReactMarkdown remarkPlugins={[gfm]}>{postMarkdown}</ReactMarkdown> */}
        <Title>عن الشركة</Title>
        <SubTitle>
          شركة تطوير لخدمات النقل التعليمي، المملوكة لصندوق الاستثمارات العامة،
          تعد مساهماً رئيساً في تنمية وتطوير قطاع النقل في المملكة العربية
          السعودية، وخاصة النقل التعليمي، وتعتمد أفضل الممارسات ونماذج التشغيل
          والتقنيات الإبداعية التي تلبي متطلبات حلول النقل والخدمات اللوجستية
          الخاصة بها.
        </SubTitle>

        <Title>خدماتنا</Title>
        <SubTitle>
          تقوم شركة تطوير النقل بتقديم حلول تقديم خدمة النقل والخدمات المساندة
          واللوجستية لتمكين العملاء من توفير خدمات عالية الموثوقية وذات جودة
          وكفاءة عالية.
        </SubTitle>

        <Services>
          <Service>النقل التعليمي</Service>
          <Service>النقل المتخصص</Service>
          <Service>إدارة عمليات التعاقد والنقل</Service>
          <Service>الرقابة والإشراف</Service>
          <Service>الخدمات والحلول التقنية</Service>
          <Service>الدراسات والاستشارات</Service>
          <Service>الخدمات المساندة</Service>
        </Services>
        <Spacer />
      </Main>
    </Layout>
  );
};
const Spacer = styled.div`
  height: 200px;
`;
const Services = styled.div`


grid-column-gap:20px;
grid-row-gap:20px;
display:grid;
grid-template-columns:1fr 1fr;

`;
const Service = styled.div`
font-weight:bold;
font-size:1.4em;
background-color:#fff;
color: #222;
`;

const Main = styled.div`
  direction: rtl;
  text-align: center;
  padding: 46px;
  overflow: auto;
  height: 100vh;
  background-color: #b4b4b4;
  color: #fafafa;
  /* display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center; */

`;

const Title = styled.h1``;
const SubTitle = styled.h2``;
export default Page;
